var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "gray",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15053 0.279606L2.27614 0.390524L8 6.11333L13.7239 0.390524C14.2446 -0.130175 15.0888 -0.130175 15.6095 0.390524C16.0901 0.87117 16.1271 1.62748 15.7204 2.15053L15.6095 2.27614L9.88667 8L15.6095 13.7239C16.1302 14.2446 16.1302 15.0888 15.6095 15.6095C15.1288 16.0901 14.3725 16.1271 13.8495 15.7204L13.7239 15.6095L8 9.88667L2.27614 15.6095C1.75544 16.1302 0.911223 16.1302 0.390524 15.6095C-0.090121 15.1288 -0.127094 14.3725 0.279606 13.8495L0.390524 13.7239L6.11333 8L0.390524 2.27614C-0.130175 1.75544 -0.130175 0.911223 0.390524 0.390524C0.87117 -0.090121 1.62748 -0.127094 2.15053 0.279606Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.7ae494f49e8eb4a637f92a9c6c9635fd.svg";
export { ForwardRef as ReactComponent };